module.exports = __webpack_public_path__ + "static/media/black-widow-icon.aa044fb2.png";